import {useEffect, useRef} from "react";
import {useLocation} from "react-router-dom";

export function AboutUs({enddate,counter}){
    const whatisbenefitshare = useRef(null);
    const whatmakesbenefitsharedifferent = useRef(null);
    const location = useLocation(); // Aktuális URL-t figyeljük
    useEffect(() => {
        const nav = document.querySelector('nav');
        const navHeight = nav ? nav.offsetHeight : 0;

        // scroll függvény kis helperként
        const scrollToRef = (ref) => {
            if (ref && ref.current) {
                const sectionTop = ref.current.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: sectionTop - navHeight,
                    behavior: 'smooth'
                });
            }
        };

        // Delay-t is belerakunk, hogy biztos minden renderelődjön
        const scrollTimeout = setTimeout(() => {
            if (location.hash === '#miazabenefitshare') {
                scrollToRef(whatisbenefitshare);
            }
            if (location.hash === '#mitolmasabenefitshare') {
                scrollToRef(whatmakesbenefitsharedifferent);
            }
        }, 500); // 100ms delay segít a komponens renderelés után

        return () => clearTimeout(scrollTimeout); // tisztítás ha kell
    }, [location.hash, whatisbenefitshare.current, whatmakesbenefitsharedifferent.current]);

    return (
        <section className="pt-0 sm-pt-50px">
            <div className="container">
                <div className="row row-cols-1 row-cols-lg-3 row-cols-md-2 justify-content-center mb-7"
                     data-anime={JSON.stringify({
                         "el": "childs",
                         "translateY": [30, 0],
                         "opacity": [0, 1],
                         "duration": 600,
                         "delay": 0,
                         "staggervalue": 300,
                         "easing": "easeOutQuad"
                     })}>
                    <section className="bg-dark-midnight-blue pt-0">
                        <div className="container">
                            <div ref={whatmakesbenefitsharedifferent} className="row align-items-center">
                                <div className="col-lg-6 md-mb-30px">
                                    <figure className="position-relative mb-50px sm-ps-50px">
                                        <div className="overflow-hidden border-radius-4px position-relative"
                                             data-parallax-liquid="true" data-parallax-transition="1"
                                             data-parallax-position="top">
                                            <div className="liquid-parallax" data-parallax-liquid="true"
                                                 data-parallax-position="bottom" data-parallax-scale="1"
                                                 data-parallax-scale-fraction="0.0001"
                                                 data-anime='{ "effect": "slide", "direction": "tb", "color": "#17161a", "duration": 1000, "delay": 0 }'>
                                                <img src="/benefitshare/img/rolunk3.jpg" alt=""
                                                     className="w-100 border-radius-5px"/>
                                            </div>
                                        </div>
                                        <figcaption
                                            className="position-absolute z-index-1 bottom-minus-50px lg-bottom-minus-30px sm-bottom-minus-50px left-minus-50px lg-left-minus-30px sm-left-minus-0px w-50 md-w-220px text-center last-paragraph-no-margin"
                                            data-anime='{ "translateY": [0, 0], "opacity": [0,1], "duration": 600, "delay": 1000, "staggervalue": 300, "easing": "easeOutQuad" }'>
                                            <div className="atropos" data-atropos>
                                                <div className="atropos-scale">
                                                    <div className="atropos-rotate">
                                                        <div
                                                            className="atropos-inner border-radius-5px bg-base-color text-white ps-12 pe-12 pt-50px pb-50px lg-pt-35px lg-pb-35px"
                                                            data-atropos-offset="3"><span
                                                            className="fs-130 lg-fs-110 d-inline-block ls-minus-5px fw-600 text-shadow-double-large text-outline text-outline-width-2px alt-font">{counter}</span>
                                                            <span
                                                                className="alt-font text-uppercase fw-500 ls-2px fs-17 lh-24 d-inline-block"><p>ELŐADÓVAL</p></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </figcaption>
                                    </figure>
                                </div>
                                <div className="col-xl-5 offset-xl-1 col-lg-6 text-center text-lg-start"
                                     data-anime={JSON.stringify({
                                         "el": "childs",
                                         "translateY": [30, 0],
                                         "opacity": [0, 1],
                                         "duration": 600,
                                         "delay": 0,
                                         "staggervalue": 200,
                                         "easing": "easeOutQuad"
                                     })}>
                                    <h2 className="alt-font fw-500 ls-minus-2px text-dark-gray"><span
                                        className="w-20px h-4px d-inline-block bg-base-color me-10px"></span>Mitől más a
                                        BeneFit SHARE?</h2>
                                    <p className="lg-w-95 mx-auto" style={{textAlign:'justify'}}>HR szakemberek tanulnak HR szakemberektől – közösen, együtt gyarapítva tudásukat, egymást támogatva és segítve ebben a kihívásokkal teli területen. Egy olyan szakmai térben, ahol a tudás megosztása és az inspiráció közösen formálja a jövő munkahelyeit.</p>
                                    <div className="d-inline-block mt-10px lg-mt-0"><a href="video/video.mp4"
                                                                                       className="popup-youtube"> </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div ref={whatisbenefitshare} className="row mb-10 align-items-center">
                    <div className="col-lg-5 position-relative md-mb-20">
                        <div className="w-70 xs-w-80" data-animation-delay="50" data-shadow-animation="true">
                            <img src="/benefitshare/img/rolunk2.jpg" alt="" className="border-radius-8px w-100"/>
                        </div>
                        <div
                            className="w-60 overflow-hidden position-absolute right-minus-15px xs-right-15px xs-w-60 bottom-minus-50px"
                            data-shadow-animation="true" data-animation-delay="250"
                            data-bottom-top="transform: translateY(50px)"
                            data-top-bottom="transform: translateY(-50px)">
                            <img src="/benefitshare/img/rolunk1.jpg" alt=""
                                 className="border-radius-8px w-100 box-shadow-quadruple-large"/>
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-6 offset-lg-1"
                         data-anime={JSON.stringify({
                             "el": "childs",
                             "translateY": [30, 0],
                             "opacity": [0, 1],
                             "duration": 600,
                             "delay": 0,
                             "staggervalue": 300,
                             "easing": "easeOutQuad"
                         })}>
                        <span
                            className="ps-25px pe-25px mb-20px text-uppercase text-base-color fs-12 lh-40 fw-700 border-radius-100px bg-gradient-very-light-gray-transparent d-inline-flex"><i
                            className="bi bi-award fs-16 me-5px"></i>ISMERJ MEG MINKET</span>
                        <h3 className="text-dark-gray fs-50 fw-700 ls-minus-2px">Mi az a BeneFit SHARE?</h3>
                        <p className="mb-40px sm-mb-25px" style={{textAlign:"justify"}}>A BeneFit SHARE konferencia célja, hogy valódi, gyakorlatban is működő példákon keresztül nyújtson inspirációt mindazoknak, akik tenni szeretnének a munkavállalói jóllétért. Korábbi BeneFit PRIZE díjas vállalatok osztják meg tapasztalataikat és őszintén beszélnek sikerekről, tanulságokról – sőt, a nehézségekről is.
                            <br/><br/>Ha érdekel, hogyan lehet a gondoskodásból versenyelőnyt kovácsolni – itt a helyed!
                            Gyere és tanulj a legjobbaktól, készülj tudatosan az idei pályázati időszakra, hogy 2025-ben már Te és a vállalatod legyen a BeneFit PRIZE Díj nyertese!
                        </p>
                        <div className="progress-bar-style-02">
                            <div className="progress mb-15px border-radius-50px fw-700 fs-11 lh-11 text-white bg-white">
                                <div className="progress-bar bg-gradient-flamingo-red-transparent m-0"
                                     role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"
                                     aria-label="business"><span
                                    className="progress-bar-percent text-flamingo">100%</span>
                                </div>
                                <div className="progress-bar-title text-uppercase">Tudásmegosztás</div>
                            </div>
                            <div className="progress border-radius-50px fw-700 fs-11 lh-11 text-white bg-white">
                                <div className="progress-bar bg-gradient-base-color-transparent m-0" role="progressbar"
                                     aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" aria-label="technology"><span
                                    className="progress-bar-percent text-flamingo">100%</span>
                                </div>
                                <div className="progress-bar-title text-uppercase">Kapcsolatépítés</div>
                            </div>
                        </div>
                    </div>
                </div>
                <center>
                    <div className="countdown-style-03 mb-0 mt-0">
                        <div data-enddate={enddate} className="countdown"></div>
                    </div>
                </center>
            </div>
        </section>
    )
}